import { Component, EventEmitter, Input, Output } from '@angular/core';

/** What a tag stands for, and so its colour. */
export type TagTone = 'neutral' | 'info' | 'success' | 'warning' | 'error';

const COLORS: Record<TagTone, string | undefined> = {
  neutral: undefined,
  info: 'blue',
  success: 'green',
  warning: 'orange',
  error: 'red'
};

/**
 * A short label, coloured by its tone; `closeable` adds a × that emits `closed`:
 *
 *     <gains-tag tone="info" [closeable]="true" (closed)="remove(filter)">{{ filter.Prompt }}</gains-tag>
 */
@Component({
  selector: 'gains-tag',
  standalone: false,
  template: `<nz-tag [nzColor]="color" [nzMode]="closeable ? 'closeable' : 'default'" (nzOnClose)="closed.emit()"><ng-content></ng-content></nz-tag>`,
  styles: [':host { display: inline-flex; } nz-tag { margin-inline-end: 0; }']
})
export class GainsTagComponent {
  @Input() tone: TagTone = 'neutral';
  @Input() closeable = false;
  @Output() closed = new EventEmitter<void>();

  get color(): string | undefined {
    return COLORS[this.tone];
  }
}
